module.exports = __webpack_public_path__ + "static/media/mel.63c1c762.jpg";